import { useCallback, useState } from "react";

const EMPTY_NOTES_MODAL = {
  open: false,
  text: "",
  callId: "",
};

const useCallNotesModal = () => {
  const [notesModal, setNotesModal] = useState(EMPTY_NOTES_MODAL);

  const openNotesModal = useCallback((callId = "", text = "") => {
    setNotesModal({ open: true, text, callId });
  }, []);

  const closeNotesModal = useCallback(() => {
    setNotesModal(EMPTY_NOTES_MODAL);
  }, []);

  const setNotesText = useCallback((text) => {
    setNotesModal((prev) => ({ ...prev, text }));
  }, []);

  return {
    notesModal,
    openNotesModal,
    closeNotesModal,
    setNotesText,
  };
};

export default useCallNotesModal;
